import { Formik, FormikConfig } from "formik";
import { isFunction } from "lodash";
import React from "react";
import { ConfirmLeaveModal } from "./ConfirmLeaveModal";

interface XolaFormikProps<T> extends FormikConfig<T> {
    enablePrompt?: boolean;
}

export const XolaFormik = <T extends Record<string, any>>({
    enablePrompt = true,
    children,
    onSubmit,
    initialValues,
    ...rest
}: XolaFormikProps<T>) => (
    <Formik<T> initialValues={initialValues} onSubmit={onSubmit} {...rest}>
        {(props) => (
            <>
                {enablePrompt && <ConfirmLeaveModal dirty={props.dirty} submitCount={props.submitCount} />}

                {isFunction(children) ? children(props) : children}
            </>
        )}
    </Formik>
);
